import { useMemo, useState, useEffect } from 'react';
import { resolveUiLocale } from '../constants/locale';

/** Reactive Info language from the system language list. */
export function useUiLocale() {
  const [locale, setLocale] = useState(() => resolveUiLocale());

  useEffect(() => {
    const sync = () => setLocale(resolveUiLocale());
    sync();
    window.addEventListener('languagechange', sync);
    return () => window.removeEventListener('languagechange', sync);
  }, []);

  return useMemo(() => locale, [locale]);
}

/** Info button label is always English "Info" (not localized). */
export function infoLabel() {
  return 'Info';
}
